module.exports = __webpack_public_path__ + "img/main-dec.e381cbdb.jpg";